import { createSlice } from "@reduxjs/toolkit";
import { IBeneficiary, IBneficiariesList } from "../../types/index";
import { logout, setProduct } from "./authSlice";

interface DashboardState {
  beneficiariesList: Array<IBneficiariesList> | []
  beneficiaries: Array<IBeneficiary> | []
}

const initialState: DashboardState = {
  beneficiariesList: [],
  beneficiaries: []
}

export const employeesSlice = createSlice({
  name: "Beneficiary",
  initialState,
  reducers: {
    addBeneficiariesList:(state, action)=>{
      state.beneficiariesList = action.payload;
    },
    addBeneficiareies: (state, action) => {
      state.beneficiaries = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, (state) => {
      state = {...initialState};
      return state;
    });
    builder.addCase(setProduct, (state) => {
      state = {...initialState};
      return state;
    });
  }
})

export const {
  addBeneficiariesList,
  addBeneficiareies
} = employeesSlice.actions;

export default employeesSlice.reducer;
